<template>
    <div v-if="showCamera" class="camera-container" ref="descriptionCard" v-bind:data-value="cardDescription">
        <div class="cameraContainer__text">
            <h2>Enquadre a foto dentro do retângulo abaixo</h2>
        </div>
        <div class="cameraContainer__video">
            <video ref="video" autoplay></video>
            <div class="focus-rectangle"></div>
        </div>
        <div class="cameraContainer__button">
            <button @click.prevent="capturePhoto">
                <img src="../../../public/images/photo_camera.svg" alt="">
            </button>
        </div>
    </div>
    <div class="container gap-32 containerCustom" v-else>
        <HeaderTitle :titleName="'Cadastro'"/>
        <div class="options-container">
            <div class="cardUploadFiles" ref="descriptionCard" v-bind:data-value="cardDescription" v-if="isVisiblePrimary">
                <div class="cardUploadFiles__instructions">
                    <div class="instructions__iconVehicle">
                        <img :src="srcExampleImage" alt="">
                    </div>
                    <div class="instructions__text">
                        <h2>{{ titleCard }}</h2>
                        <span>Sua foto deve ter no máximo 5 MB</span>
                    </div>
                </div>
                <div class="cardUploadFiles__buttons">
                    <button class="button button--primary button--medium custom" @click.prevent="openCamera">
                        <img src="../../../public/images/photo_camera.svg" alt="">
                        <span class="buttonTakePicture">Tirar uma foto</span>
                    </button>
                    <button type="button" class="button button--text-button-primary custom" @click.prevent="openFiles">
                        <img src="../../../public/images/add.svg" alt="">
                        <span class="buttonSearch">Busque no dispositivo</span>
                    </button>
                    <input type="file" ref="fileInput" accept="image/*" capture="camera" @change="showPreview" style="display: none;">
                </div>
            </div>

            <div class="cardUploadFiles" ref="descriptionCard" v-bind:data-value="cardDescription" v-else>
                <div class="cardUploadFiles__instructions">
                    <div class="instructions__iconVehicleSecond">
                        <img :src="srcExampleImage" alt="">
                    </div>
                    <div class="instructions__text">
                        <h2>{{ titleCard }}</h2>
                        <span>Sua foto deve ter no máximo 5 MB</span>
                    </div>
                    <div class="intructions__attention">
                        <div class="attention__cardAttention">
                            <img src="../../../public/images/warning.svg" alt="">
                            <span>{{ textCardAttention }}</span>
                        </div>
                        <div class="attention__cardAttention" v-if="isVisibleSecondaryCard">
                            <img src="../../../public/images/warning.svg" alt="">
                            <span>{{ textSencondaryCardAttention }}</span>
                        </div>
                        <div class="attention__text" v-if="isVisibleTextList">
                            <ul>
                                <li>As informações do documento devem estar visíveis na foto</li>
                                <li>Não utilize o flash da câmera</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="cardUploadFiles__buttons">
                    <button class="button button--primary button--medium custom" @click.prevent="openCamera">
                        <img src="../../../public/images/photo_camera.svg" alt="">
                        <span class="buttonTakePicture">Tirar uma foto</span>
                    </button>
                    <button type="button" class="button button--text-button-primary custom" @click.prevent="openFiles">
                        <img src="../../../public/images/add.svg" alt="">
                        <span class="buttonSearch">Busque no dispositivo</span>
                    </button>
                    <input type="file" ref="fileInput" accept="image/*" capture="camera" @change="showPreview" style="display: none;">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { useStore } from '../../stores/cadastro';
    import { useRouter, useRoute } from 'vue-router';
    import { nextTick } from 'vue';
    import HeaderTitle from '../components/HeaderTitle.vue';
    import Swal from 'sweetalert2';

    export default {
        components: {
            HeaderTitle
        },
        setup() {
            const store = useStore();
            const router = useRouter();
            const route = useRoute();

            return {
                store,
                router,
                route
            }
        },
        data() {
            return {
                showCamera: false,
            }
        },
        props: {
            cardDescription: {
                type: String,
                required: true
            },
            srcExampleImage: {
                type: String,
                required: true
            },
            titleCard: {
                type: String,
                required: true
            },
            textCard: {
                type: String,
                required: true
            },
            isVisibleTextList: {
                type: Boolean,
                required: false,
                default: false
            },
            textCardAttention: {
                type: String,
                required: true
            },
            isVisibleSecondaryCard: {
                type: Boolean,
                required: false,
                default: false
            },
            textSencondaryCardAttention: {
                type: String,
                required: false
            },
            nextRoute: {
                type: String,
                required: true
            },
            previewScreen: {
                type: String,
                required: true
            },
            isVisiblePrimary: {
                type: Boolean,
                required: true,
                default: true
            }
        },
        beforeUnmount() {
            const video = this.$refs.video;
            if (video && video.srcObject) {
                const stream = video.srcObject;
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
                video.srcObject = null;
            }
        },
      methods: {
            async openCamera() {
                this.showCamera = true;
                nextTick(async () => {
                    const video = this.$refs.video;
                    if (video) {
                        try {
                            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                            video.srcObject = stream;
                        } catch (err) {
                            console.error('Erro ao acessar a câmera: ', err);
                        }
                    }
                });
            },
            async capturePhoto() {
                const video = this.$refs.video;
                if (video && video.videoWidth > 0 && video.videoHeight > 0) {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const context = canvas.getContext('2d');
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const dataURL = canvas.toDataURL('image/png');
                    const blob = await fetch(dataURL).then(res => res.blob());
                    this.showPreview({ target: { files: [new File([blob], 'photo.png', { type: 'image/png' })] } });
                } else {
                    this.router.back();
                }
            },
            openFiles() {
                this.$refs.fileInput.click();
            },
            async showPreview(event) {

                const descriptionCardElement = this.$refs.descriptionCard;
                const cardDescription = descriptionCardElement.getAttribute('data-value');
                const textCard = this.textCard;
                const nextRoute = this.nextRoute;
                const file = event.target.files[0];
                const imageUrl = URL.createObjectURL(file);
                const PreviewScreen = this.previewScreen

                const maxSizeMB = 5;
                const maxSizeBytes = maxSizeMB * 1024 * 1024;

                if (file.size > maxSizeBytes) {
                    Swal.fire({
                    title: 'Ops...',
                    text: 'O arquivo que você tentou enviar é maior que 5MB',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                    });
                    return;
                }

                this.$router.push({ name: PreviewScreen, query: { urlImageUploaded: imageUrl, routeName: cardDescription, textCard: textCard, nextRoute: nextRoute}, state: { file } });
            },
        }
    }
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .containerCustom {
        margin-top: 24px;
    }
    .cardUploadFiles {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .cardUploadFiles__instructions {
        height: 60vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 32px;
        padding: 8px;
        padding-top: 70.75px;
        padding-bottom: 70.75px;
    }
    .instructions__iconVehicle {
        width: 60%;
        height: 60%;
    }
    .instructions__iconVehicleSecond {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .instructions__iconVehicle img {
        width: 100%;
        height: 100%;
    }
    .instructions__text {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
    .instructions__text h2 {
        font-size: 18px;
        text-align: center;
        color: #22232C;
        font-weight: 500;
    }
    .instructions__text span {
        font-size: 14px;
        color: #22232C;
        font-weight: 400;
    }
    .intructions__attention {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
    }
    .attention__cardAttention {
        display: flex;
        flex-direction: row;
        gap: 16px;
        width: 90%;
        padding: 16px;
        background-color: #FFEAB9;
        border: 1px solid #F6BE01;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #22232C;
    }
    .attention__text ul li {
        font-size: 14px;
        font-weight: 500;
        color: #435254;
        line-height: 21px;
    }
    .cardUploadFiles__buttons {
        background-color: #FFF;
        width: 100%;
        box-shadow  : 0px -5px 5px 0px #0000001A;
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 24px;
    }
    .custom {
        display: flex;
        flex-direction: row;
        gap: 8px;
        font-size: 16px;
        font-weight: 500;
    }
    .button--medium {
        color: #22232C;
    }
    .button--text-button-primary {
        color: #435254 ;
    }
    .cardUploadFiles__status {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        padding: 8px;
    }
    .status__text {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .status__text h2 {
        font-size: 18px;
        color: #22232C;
        font-weight: 500;
    }
    .status__text span {
        font-size: 14px;
        color: #435254;
        font-weight: 400;
    }
    .camera-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .cameraContainer__text {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        color: white;
        text-align: center;
        width: 100%;
    }
    .cameraContainer__text h2 {
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 28px;
    }
    .cameraContainer__video {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .cameraContainer__video video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .cameraContainer__button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        background-color: #F6BE01;

        width: 48px;
        height: 48px;
        border-radius: 100%;
    }
    .focus-rectangle {
        position: absolute;
        top: 10%;
        left: 16px;
        right: 16px;
        bottom: 10%;
        background-size: cover;
        box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.5);
        filter: none;
    }

</style>
